let isRedirecting = false;

/**
 * Checks if a JWT token was issued before the most recent 12:00 AM IST.
 * If issued before today's 12:00 AM IST, the session is expired according to the midnight reset policy.
 */
export const isTokenExpiredMidnight = (token) => {
  if (!token || typeof token !== "string") return false;
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return false;
    let base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    while (base64.length % 4) {
      base64 += "=";
    }
    const payload = JSON.parse(decodeURIComponent(escape(atob(base64))));
    if (!payload || !payload.iat) return false;

    const tokenIssueTime = payload.iat * 1000;

    // Current time in Asia/Kolkata (IST = UTC + 5:30)
    const now = new Date();
    const istOffsetMs = 5.5 * 60 * 60 * 1000;
    const istTime = new Date(now.getTime() + istOffsetMs);
    const istMidnight = new Date(
      Date.UTC(
        istTime.getUTCFullYear(),
        istTime.getUTCMonth(),
        istTime.getUTCDate(),
        0,
        0,
        0,
        0
      )
    );
    const midnightEpoch = istMidnight.getTime() - istOffsetMs;

    return tokenIssueTime < midnightEpoch;
  } catch (e) {
    return false;
  }
};

export const handleSessionExpired = () => {
  if (isRedirecting) return;
  const currentPath = window.location.pathname;
  const isAuthPage =
    currentPath === "/loginPage" ||
    currentPath === "/login" ||
    currentPath === "/forgot-password" ||
    currentPath === "/reset-password";

  window.localStorage.clear();
  window.sessionStorage.clear();

  if (!isAuthPage) {
    isRedirecting = true;
    window.location.replace("/loginPage");
  }
};

export const isExpiredPayload = (data) => {
  if (!data) return false;
  const is401 =
    data.statusCode === "401" ||
    data.status === "401" ||
    data.statusCode === 401 ||
    data.status === 401;
  const isExpiredMsg =
    typeof data.message === "string" &&
    (data.message.toLowerCase().includes("session expired") ||
      data.message.toLowerCase().includes("token expire") ||
      data.message.toLowerCase().includes("auth failed") ||
      data.message.toLowerCase().includes("unauthorized") ||
      data.message.toLowerCase().includes("not authorized"));
  return is401 || isExpiredMsg;
};

// Suppress blocking browser alert for 401 errors globally and redirect immediately
if (typeof window !== "undefined") {
  const originalAlert = window.alert;
  window.alert = function (msg) {
    if (
      typeof msg === "string" &&
      (msg.includes("401") ||
        msg.toLowerCase().includes("session expired") ||
        msg.toLowerCase().includes("token expire") ||
        msg.toLowerCase().includes("unauthorized"))
    ) {
      handleSessionExpired();
      return;
    }
    return originalAlert.apply(this, arguments);
  };
}

const requestMiddleWare = (config) => {
  const token = window.localStorage.getItem("userToken");
  const headers = {
    "content-type": "application/json; charset=UTF-8",
    authorization: `Bearer ${token}`,
    ...config.headers, // Spread existing headers from config
  };

  // Merge the headers into the config
  return { ...config, headers };
};

const responseMiddleWare = (response) => {
  const data = response?.data;
  if (isExpiredPayload(data)) {
    handleSessionExpired();
  }
  return response?.data;
};

const errorHandlerMiddleWare = (error) => {
  const status = error?.response?.status;
  const data = error?.response?.data;
  if (status === 401 || isExpiredPayload(data) || error?.message?.includes("401")) {
    handleSessionExpired();
  }
  return Promise.reject(error);
};

export {
  requestMiddleWare,
  responseMiddleWare,
  errorHandlerMiddleWare,
};
